var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGastroenterology(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD3C5",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M27.988,12.309c0,0-1.688-3.479-4.897-2.681 c0,0-3.016,0.902-4.278-1.495c0,0-0.913-1.373-0.287-3.729h-2.687c-0.266,1.374-0.34,3.839,1.557,6.384 c0,0,2.655,3.067,0.954,6.031c0,0-1.778,3.686-6.804,2.294c0,0-0.876-0.412-1.933-1.031c-0.917-0.537-3.789-1.443-5.722,1.649 c0,0-0.852,1.298-0.915,3.162h2.658c0.003-0.057,0.004-0.114,0.009-0.173c0,0,0.077-2.449,1.881-2.577c0,0,1.366-0.258,2.423,2.113 c0,0,1.65,4.356,6.572,4.871c0,0,5.747,1.031,10.077-4.072C26.596,23.056,30.952,18.082,27.988,12.309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M22.472,11.278c0,0,3.505-0.799,4.717,3.428 c0,0,1.598,5.026-3.608,8.918c0,0-6.076,4.536-10.773-0.103c0,0-1.959-2.294,0.077-2.449c0,0,4.82,0.129,6.701-3.196 c0,0,1.012-1.759,0.773-4.098C20.359,13.778,20.068,11.566,22.472,11.278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B5889",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M13.155,21.645c0,0,3.19,0.155,5.78-2.049 c0,0,0.387-0.309,0.812,0.116c0,0,0.251,0.329,0.735-0.135c0,0,0.483-0.348,0.87,0.174c0,0,0.271,0.193,0.638-0.155 c0,0,0.503-0.348,0.909,0.155c0,0,0.271,0.193,0.677-0.155c0,0,0.503-0.309,0.851,0.174c0,0,0.251,0.251,0.773-0.213 c0,0,0.483-0.309,0.831,0.213c0,0-1.952,4.485-7.172,5.122c0,0-4.62,0.561-6.166-2.842C12.691,22.051,12.421,21.568,13.155,21.645z "
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    cx: 16.374,
    cy: 22.982,
    r: 0.464
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M19.455,21.635 c0,0.432-0.351,0.783-0.783,0.783c-0.432,0-0.783-0.351-0.783-0.783c0-0.432,0.351-0.783,0.783-0.783 C19.104,20.852,19.455,21.203,19.455,21.635z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    cx: 20.686,
    cy: 23.098,
    r: 0.532
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M21.404,21.063 c0,0.267-0.216,0.483-0.483,0.483c-0.267,0-0.483-0.216-0.483-0.483c0-0.267,0.216-0.483,0.483-0.483 C21.188,20.58,21.404,20.796,21.404,21.063z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    cx: 23.305,
    cy: 21.074,
    r: 0.561
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    cx: 18.34,
    cy: 23.739,
    r: 0.358
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M14.809,22.638c0,0.16-0.13,0.29-0.29,0.29 c-0.16,0-0.29-0.13-0.29-0.29c0-0.16,0.13-0.29,0.29-0.29C14.679,22.348,14.809,22.478,14.809,22.638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B5889",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M21.97,17.962 c0,0.39-0.316,0.706-0.705,0.706c-0.39,0-0.706-0.316-0.706-0.706c0-0.39,0.316-0.706,0.706-0.706 C21.654,17.256,21.97,17.572,21.97,17.962z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#2B5889",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    cx: 25.198,
    cy: 16.154,
    r: 0.947
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#2B5889",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    cx: 22.25,
    cy: 14.231,
    r: 0.725
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B5889",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M25.391,13.448 c0,0.267-0.216,0.483-0.483,0.483c-0.267,0-0.483-0.216-0.483-0.483s0.216-0.483,0.483-0.483 C25.175,12.965,25.391,13.181,25.391,13.448z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#2B5889",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    cx: 22.724,
    cy: 16.521,
    r: 0.387
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B5889",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M24.773,18.387 c0,0.219-0.177,0.396-0.396,0.396c-0.219,0-0.396-0.177-0.396-0.396c0-0.219,0.177-0.396,0.396-0.396 C24.595,17.991,24.773,18.168,24.773,18.387z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGastroenterology);
export default __webpack_public_path__ + "static/media/gastroenterology.dbaafc9456720c3e1584a5ca277adb19.svg";
export { ForwardRef as ReactComponent };